// extracted by mini-css-extract-plugin
export var embed = "Video-module--embed--e19d8";
export var icon = "Video-module--icon--7624f";
export var player = "Video-module--player--f6116";
export var video = "Video-module--video--5f8e0";